'use client'
import { createRoot } from 'react-dom/client';
import * as React from 'react';
import { CalendlyModal } from '../ui/calendly-modal';
import { CalendlyProps } from '../lib/types';
import { logEvent } from '@coverright/shared/analytics/logEvent';
import { useClientAgent } from '@coverright/shared/contexts/agent-context';
import { ThemeProvider } from '@mui/material';

export function useCalendlyModal() {
  const {agent} = useClientAgent();

  return (props?: CalendlyProps & { width?: number | string, subtitle?: string }) => {
    return new Promise<boolean>((resolve) => {
      const container = getContainer();
      const root = createRoot(container);

      document.body.style.setProperty('overflow', 'hidden');
      document.body.style.setProperty('padding-right', '15px');

      const modal = (
        <CalendlyModal
          agent={agent}
          {...props}
          logEvent={logEvent}
          onClose={(value: boolean) => {
            resolve(value);
            const modal = document.getElementById('calendly-modal');
            if (modal) {
              document.body.removeChild(modal);
            }
            if (container) {
              container.remove();
            }
            document.body.style.setProperty('overflow', null);
            document.body.style.setProperty('padding-right', null);
          }}
        />
      );

      const component = props?.theme ? <ThemeProvider theme={props.theme}>{modal}</ThemeProvider> : modal;
      root.render(component);
    });
  };
}

const getContainer = () => {
  let div: any;
  if (!document.getElementById('calendly-modal-container')) {
    div = document.createElement('div');
    div.id = 'calendly-modal-container';
    document.body.appendChild(div);
  }
  return document.getElementById('calendly-modal-container') as HTMLElement;
}
